"use client";
import React, { useState, useEffect } from "react";
import Image from "next/image";
import search from "@/public/images/search.svg";
import { useForm, Controller } from "react-hook-form";
import FacultyCard2 from "@/components/shared/FacultyCard2";
import { Faculty } from "@/types/Faculty";
import { useTranslate } from "@/components/base/providers/TranslateProv";

interface ExistedFacultyProps {
  item: Faculty;
}

const ItsItems: React.FC<ExistedFacultyProps> = ({ item }) => {
  const { locale } = useTranslate();
  const [filteredSpecializations, setFilteredSpecializations] = useState(
    item?.specialization || []
  );

  const { control, watch } = useForm({
    defaultValues: { search: "" },
  });

  const searchQuery = watch("search").toLowerCase();

  useEffect(() => {
    const filtered = item?.specialization?.filter((specialize: Faculty) => {
      const nameMatch = specialize?.name[locale as "ar" | "en"]
        .toLowerCase()
        .includes(searchQuery);
      const descriptionMatch = specialize?.short_description[
        locale as "ar" | "en"
      ]
        .toLowerCase()
        .includes(searchQuery);

      return nameMatch || descriptionMatch;
    });

    setFilteredSpecializations(filtered);
  }, [searchQuery, item?.specialization, locale]);

  return (
    <>
      <p className="text-25 text-[#141522] font-[600] text-center mb-5">
        {locale === "ar" ? " التخصصات الموجوده في " : " Programs in "}
        {item.name[locale as "ar" | "en"]}
      </p>
      <div className="relative container w-full bg-white p-3 rounded-[10px] mx-auto border border-[#E0E0E0] mb-5">
        <form className="relative">
          <Controller
            name="search"
            control={control}
            render={({ field }) => (
              <input
                {...field}
                type="text"
                className="w-full h-[60px] bg-[#F8F9FA] rounded-[10px] py-3 px-14"
                placeholder={
                  locale === "en" ? "Search for specialization" : "بحث عن تخصص"
                }
              />
            )}
          />
          <Image
            src={search}
            alt="search"
            style={locale === "ar" ? { right: "20px" } : { left: "20px" }}
            className="absolute top-1/2 -translate-y-1/2 "
          />
        </form>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {filteredSpecializations?.length > 0 ? (
          filteredSpecializations?.map((specialize: Faculty, index: number) => (
            <FacultyCard2
              key={index}
              university={item.university}
              faculty={specialize}
              specialize={true}
              hide={true}
              onlyHideImage={true}
            />
          ))
        ) : (
          <p className="text-center col-span-full">
            {locale === "en"
              ? "No specializations found."
              : "لم يتم العثور على تخصصات."}
          </p>
        )}
      </div>
    </>
  );
};

export default ItsItems;
